import { BaseService, RequestType, ResponseType } from "@intech/react-service";
import { ContratoEntidade } from "../entidades/ContratoEntidade";
import { PrestacaoEntidade } from "../entidades/PrestacaoEntidade";
import { ModalidadeEntidade } from "../entidades/ModalidadeEntidade";
import { ContratoDisponivelEntidade } from "../entidades/ContratoDisponivelEntidade";
import { ParametrosContrato, ParametrosSimulacao } from "../entidades";
import { SitContratoEntidade } from "../entidades/SitContratoEntidade";

class Emprestimo extends BaseService {
  constructor() {
    super("Emprestimo");
  }

  Buscar = () =>
    this.CreateRequest<Array<ContratoEntidade>>(RequestType.GET, `Buscar`);

  BuscarPorSituacao = (situacao: number) =>
    this.CreateRequest<Array<ContratoEntidade>>(RequestType.GET, `BuscarPorSituacao/${situacao}`);

  BuscarSituacoes = () =>
    this.CreateRequest<Array<SitContratoEntidade>>(RequestType.GET, `BuscarSituacoes`);

  BuscarAtivos = (dataCredito: string) =>
    this.CreateRequest<Array<ContratoEntidade>>(RequestType.GET, `BuscarAtivos/${dataCredito}`);

  BuscarDetalhePorNumeroAno = (numero: string, ano: string) =>
    this.CreateRequest<ContratoEntidade>(RequestType.GET, `BuscarDetalhePorNumeroAno/${numero}/${ano}`);

  BuscarPrestacoesPorNumeroAno = (numero: string, ano: string) =>
    this.CreateRequest<Array<PrestacaoEntidade>>(RequestType.GET, `BuscarPrestacoesPorNumeroAno/${numero}/${ano}`);

  BuscarModalidades = () =>
    this.CreateRequest<Array<ModalidadeEntidade>>(RequestType.GET, `BuscarModalidades`);

  BuscarAutorizacaoMargem = (cdPlano: string) =>
    this.CreateRequest<boolean>(RequestType.GET, `BuscarAutorizacaoMargem/${cdPlano}`);

  BuscarLimiteUnicoDataCredito = (cdPlano: string) =>
    this.CreateRequest<any>(RequestType.GET, `BuscarLimiteUnicoDataCredito/${cdPlano}`);

  BuscarParcelas = (parametros: ParametrosSimulacao) =>
    this.CreateRequest<Array<ContratoDisponivelEntidade>>(RequestType.POST, `BuscarParcelas`, parametros);

  Contratar = (dados: ParametrosContrato) =>
    this.CreateRequest<string>(RequestType.POST, `Contratar`, dados);

  // Upload = (model: FileUploadEntidade) =>
  // 	this.CreateRequest<any>(RequestType.POST, `Upload`, model);

  GerarToken = () =>
    this.CreateRequest<string>(RequestType.GET, `GerarToken`);

  BuscarLinkDocumentosEmprestimo = () =>
    this.CreateRequest<string>(RequestType.GET, `BuscarLinkDocumentosEmprestimo`);

}

export const EmprestimoService = new Emprestimo();